import pdfIcon from '../../../assets/chat/icon-pdf.png';
import wordIcon from '../../../assets/chat/icon-word.png';
import {
    formatFileSize,
    getAttachmentKind,
    ATTACHMENT_KIND_LABELS,
    isImageAttachment,
    asAttachmentList,
    canPreviewInBrowser,
} from '../../../common/taskUploads';
import './task-form.css';

const FILE_KIND_ICONS = {
    pdf: pdfIcon,
    word: wordIcon,
    excel: wordIcon,
    powerpoint: wordIcon,
    file: wordIcon,
};

const FileVisual = ({ mimeType, url, previewUrl = null }) => {
    const kind = getAttachmentKind(mimeType);
    const imageSrc = previewUrl || (kind === 'image' && url ? url : null);

    if (kind === 'image' && imageSrc) {
        return (
            <div className="task-attachment__preview">
                <img src={imageSrc} alt="" width={72} height={72} />
            </div>
        );
    }

    const iconSrc = FILE_KIND_ICONS[kind] || FILE_KIND_ICONS.file;

    return (
        <span className="task-attachment__file-icon-wrap">
            <img
                src={iconSrc}
                alt=""
                className="task-attachment__file-badge"
                width={26}
                height={26}
                aria-hidden="true"
            />
        </span>
    );
};

export const TaskAttachmentCard = ({ attachment }) => {
    if (!attachment?.fileName && !attachment?.url) return null;

    const kind = getAttachmentKind(attachment.mimeType);
    const previewUrl = isImageAttachment(attachment.mimeType) ? attachment.url : null;
    const canOpen = Boolean(attachment.url) && canPreviewInBrowser(attachment.mimeType);

    return (
        <div className="task-attachment__file" data-kind={kind}>
            <FileVisual
                mimeType={attachment.mimeType}
                url={attachment.url}
                previewUrl={previewUrl}
            />
            <div className="task-attachment__file-body">
                {attachment.url ? (
                    <a
                        href={attachment.url}
                        target="_blank"
                        rel="noreferrer"
                        className="task-attachment__file-name task-attachment__file-name--link"
                    >
                        {attachment.fileName}
                    </a>
                ) : (
                    <p className="task-attachment__file-name">{attachment.fileName}</p>
                )}
                <p className="task-attachment__file-meta">
                    {ATTACHMENT_KIND_LABELS[kind]}
                    {attachment.size ? ` · ${formatFileSize(attachment.size)}` : ''}
                    {canOpen ? ' · Ver' : attachment.url ? ' · Descargar' : ''}
                </p>
            </div>
        </div>
    );
};

export const TaskAttachmentList = ({ attachments }) => {
    const list = asAttachmentList(attachments);
    if (!list.length) return null;
    return (
        <div className="task-attachment__stack">
            {list.map((attachment, index) => (
                <TaskAttachmentCard
                    key={attachment.storageKey || attachment.url || `${attachment.fileName}-${index}`}
                    attachment={attachment}
                />
            ))}
        </div>
    );
};
